import { default as tunnelRat } from 'tunnel-rat'

export const tunnel = tunnelRat()

const WebGLDomScene = () => {
  return <tunnel.Out />
}

export default WebGLDomScene
